import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../store/reducer/projectSlice";
import { createAdminUserApiCall } from "../../store/actions/projectAction";

function CreateAdminModal({ onClose }) {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [createdUser, setCreatedUser] = useState(null);
  const password = watch("password");
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    try {
      dispatch(
        setLoading({
          code: "create_admin_user",
          loading: true,
        })
      );

      const res = await dispatch(
        createAdminUserApiCall({
          data: {
            name: data.fullname,
            email: data.email,
            phone: data.phone,
            password: data.password,
            confirmPassword: data.confirmPassword,
          },
        })
      ).unwrap();

      if (res?.success) {
        setCreatedUser({
          email: res?.user?.email,
          password: data.password,
        });
        reset();
      }

      dispatch(
        setLoading({
          code: "create_admin_user",
          loading: false,
        })
      );
    } catch (error) {
      console.log(error, "error");
      dispatch(
        setLoading({
          code: "create_admin_user",
          loading: false,
        })
      );
    }
  };

  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl w-full max-w-md p-6 shadow-lg relative">
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-xl"
          onClick={onClose}
        >
          ×
        </button>

        {!createdUser ? (
          <>
            <h2 className="text-xl font-semibold mb-4 text-gray-700">
              Create Admin User
            </h2>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <label className="block text-sm mb-1">Full Name</label>
                <input
                  {...register("fullname", {
                    required: "Full Name is required",
                  })}
                  className="w-full border px-3 py-2 rounded-lg"
                />
                {errors.fullname && (
                  <p className="text-red-500 text-sm">
                    {errors.fullname.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm mb-1">Email</label>
                <input
                  type="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: "Invalid email format",
                    },
                  })}
                  className="w-full border px-3 py-2 rounded-lg"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm">{errors.email.message}</p>
                )}
              </div>

              <div>
                <label className="block text-sm mb-1">Phone</label>
                <input
                  type="tel"
                  {...register("phone", {
                    required: "Phone is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter a valid 10-digit phone number",
                    },
                  })}
                  className="w-full border px-3 py-2 rounded-lg"
                />
                {errors.phone && (
                  <p className="text-red-500 text-sm">{errors.phone.message}</p>
                )}
              </div>

              <div>
                <label className="block text-sm mb-1">Password</label>
                <input
                  type="text"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Minimum 6 characters",
                    },
                  })}
                  className="w-full border px-3 py-2 rounded-lg"
                />
                {errors.password && (
                  <p className="text-red-500 text-sm">
                    {errors.password.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm mb-1">Confirm Password</label>
                <input
                  type="text"
                  {...register("confirmPassword", {
                    required: "Confirm your password",
                    validate: (val) =>
                      val === password || "Passwords do not match",
                  })}
                  className="w-full border px-3 py-2 rounded-lg"
                />
                {errors.confirmPassword && (
                  <p className="text-red-500 text-sm">
                    {errors.confirmPassword.message}
                  </p>
                )}
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700"
                >
                  Create
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="text-center">
            <h2 className="text-xl font-semibold text-green-700 mb-4">
              Admin Created Successfully!
            </h2>
            <p className="text-gray-600 mb-2">
              <strong>Email:</strong> {createdUser.email}
            </p>
            <p className="text-gray-600 mb-6">
              <strong>Password:</strong> {createdUser.password}
            </p>

            <button
              onClick={onClose}
              className="bg-[#00428C] text-white px-6 py-2 rounded-lg hover:bg-blue-700"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CreateAdminModal;
